import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select, { createFilter } from 'react-select';
import { injectIntl } from 'react-intl';
import { Badge, Button, Collapse } from 'reactstrap';

import { addSelectedFilter, deleteSelectedFilter } from '../../actions/Files';

import FiltersResetButton from './FiltersResetButton';
import { isTrash } from '../../helpers/App';

const FiltersFileDeletedBy = ({
  intl,
  filters,
  availableFilters,
  addFilter,
  removeFilter,
  isOpen,
  handleChangeFilters,
  handleToggleFilter,
}) => {
  const getAvailableFilters = () => {
    const options = [];
    availableFilters.forEach((filter) => {
      options.push({
        value: filter.key,
        label: filter.name,
      });
    });
    return options;
  };

  const getSelectedFilters = () => {
    const values = [];
    availableFilters.forEach((filter) => {
      if (window._.includes(filters, filter.key)) {
        values.push({
          value: filter.key,
          label: filter.name,
        });
      }
    });
    return values;
  };

  const handleChangeFilter = (values, action) => {
    let newSelected = filters.slice(0);

    if (action.action === 'select-option') {
      const { option: value } = action;
      newSelected.push(value.value);
      addFilter({
        type: 'deleted_by',
        key: value.value,
        label: value.label,
        title: intl.formatMessage({ defaultMessage: 'Deleted by' }),
      });
    }

    if (action.action === 'remove-value') {
      const { removedValue: value } = action;
      newSelected = newSelected.filter((s) => s !== value.value);
      removeFilter('deleted_by', value.value);
    }

    if (action.action === 'clear') {
      getSelectedFilters().forEach((filter) => {
        newSelected = newSelected.filter((s) => s !== filter.value);
        removeFilter('deleted_by', filter.value);
      });
    }

    handleChangeFilters({ deleted_by: newSelected });
  };

  const handleReset = () => {
    handleChangeFilter([], { action: 'clear' });
  };

  const selected = getSelectedFilters();
  const availableFiltersOptions = getAvailableFilters();

  if (!isTrash()) {
    return null;
  }

  if (availableFiltersOptions.length === 0) {
    return null;
  }

  return (
    <div className="files-filter file-users-filter">
      <div className="filter-header">
        <Button onClick={handleToggleFilter} className="filter-title">
          <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
          <span>{intl.formatMessage({ defaultMessage: 'Deleted by' })}</span>
          {' '}
          {selected.length > 0 && (
            <Badge color="primary" pill>
              {selected.length}
            </Badge>
          )}
        </Button>
        {selected.length > 0 && (
          <FiltersResetButton handleReset={handleReset} />
        )}
      </div>
      <Collapse isOpen={isOpen} className="filter-body">
        <div className="filter-form file-users-filter-form file-deleted-by-filter-form">
          <Select
            id="filterFileDeletedby"
            inputId="filterFileDeletedByInput"
            classNamePrefix="filter-select"
            isClearable={false}
            isMulti
            options={availableFiltersOptions}
            filterOption={createFilter({
              ignoreAccents: false,
            })}
            onChange={handleChangeFilter}
            value={selected}
          />
        </div>
      </Collapse>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  filters: props.customFilters
    ? props.customFilters.deleted_by
    : state.Files.filters.deleted_by,
  availableFilters: state.Files.availableFilters.deleted_by,
});

const mapDispatchToProps = (dispatch, props) => ({
  addFilter:
    props.customAddFilter ||
    ((filter) => {
      dispatch(addSelectedFilter(filter));
    }),
  removeFilter:
    props.customRemoveFilter ||
    ((filterType, filterKey) => {
      dispatch(deleteSelectedFilter(filterType, filterKey));
    }),
});

FiltersFileDeletedBy.propTypes = {
  intl: PropTypes.object.isRequired,
  filters: PropTypes.array.isRequired,
  availableFilters: PropTypes.array.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FiltersFileDeletedBy),
);
